export enum Days {
  monday = 'DAYS.monday',
  tuesday = 'DAYS.tuesday',
  wednesday = 'DAYS.wednesday',
  thursday = 'DAYS.thursday',
  friday = 'DAYS.friday',
  saturday = 'DAYS.saturday',
  sunday = 'DAYS.sunday',
}
